import userFrTranslations from 'src/modules/user/Translations/FR';
import transpositionFrTranslations from 'src/modules/transposition/Translations/FR';
import teacherFrTranslations from 'src/modules/teacher/Translations/FR';
import schoolFrTranslations from 'src/modules/school/Translations/FR';
import playerFrTranslations from 'src/modules/player/Translations/FR';
import playableTranslations from 'src/modules/playable/Translations/FR';
import musicalComponentsTranslations from 'src/modules/musical-components/Translations/FR';
import midiTranslations from 'src/modules/midi/Translations/FR';
import masteriesTranslations from 'src/modules/masteries/Translations/FR';
import globalTranslations from 'src/modules/global/Translations/FR';
import catalogTranslations from 'src/modules/catalog/Translations/FR';
import ambitusDetectorTranslations from 'src/modules/ambitus/Translations/FR';
import validationTranslations from 'src/modules/validation/Translations/FR';
import playClassTranslations from 'src/modules/play-class/Translations/FR';
import onboardingFrTranslations from 'src/modules/onboarding/Translations/FR';

export default {
  failed: "L'action a échoué",
  success: "L'action a réussi",
  ...userFrTranslations,
  ...transpositionFrTranslations,
  ...teacherFrTranslations,
  ...schoolFrTranslations,
  ...playerFrTranslations,
  ...playableTranslations,
  ...musicalComponentsTranslations,
  ...midiTranslations,
  ...masteriesTranslations,
  ...globalTranslations,
  ...catalogTranslations,
  ...ambitusDetectorTranslations,
  ...validationTranslations,
  ...playClassTranslations,
  ...onboardingFrTranslations,
  routes: {
    home: 'Accueil',
    catalog: 'Morceaux',
    catalogImport: 'Ajouter mon morceau',
    challenges: 'Challenges',
    profile: 'Profil',
    onboarding: 'Onboarding',
    subscribe: "S'abonner",
    subscribeSuccess: 'Merci de votre soutien !',
    userCatalog: 'Morceaux en cours',
    userRevision: 'Contenus à réviser',
    exercise: 'Exercice',
    reading: 'Lecture',
    course: 'Cours',
    evaluation: 'Evaluation',
    lessons: 'Leçons',
    lesson: 'Leçon',
    skills: 'Compétences',
    skill: 'Compétence',
    videos: 'Vidéos',
    lyricsEditor: 'Editeur de paroles',
    handprintsAdmin: 'Handprints Admin',
    rhythmicsAdmin: 'Rythmiques Admin',
    tests: 'Tests',
    synthTest: 'Test Synthé',
    testNotification: 'Test Notification',
    login: 'Se connecter',
    signup: 'Créer un compte',
    forgotPassword: 'Changer votre mot de passe',
    changePassword: 'Nouveau mot de passe',
    maintenance: 'Maintenance',
    update: 'Mise à jour',
    updateError: 'Échec de la mise à jour',
    store: 'Application disponible sur les stores !',
    accountDeleted: 'Votre compte a été supprimé.',
    offline: 'Problème de connexion Internet',
    authentication: 'Authentication',
    progress: 'Votre progression',
    ambitus: 'Réglage de la plage vocale',
  }
};
